import { LOCALE_ID, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { LoginComponent } from './features/login/login.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ForbiddenComponent } from './features/login/forbidden/forbidden.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { BaseComponent } from './core/helper/base.component';
import { NavbarComponent } from './features/dashboard/navbar/navbar.component';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { LogoutComponent } from './features/logout/logout.component';
import { UserCacheService } from './core/user/user-cache.service';
import { WithCredentialsInterceptor } from './core/interceptors/with-credentials.interceptor';
import { SharedModule } from 'src/app/shared/shared.module';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SpinnerComponent } from './core/loader/spinner/spinner.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { NotFoundComponent } from './features/login/not-found/not-found.component';
import { OutletSelectionComponent } from './features/dashboard/outlet-selection/outlet-selection.component';
import { OutletPopupComponent } from './features/dashboard/outlet-popup/outlet-popup.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForbiddenComponent,
    DashboardComponent,
    BaseComponent,
    NavbarComponent,
    LogoutComponent,
    SpinnerComponent,
    NotFoundComponent,
    OutletSelectionComponent,
    OutletPopupComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    MatProgressSpinnerModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
    }),
  ],
  exports: [SharedModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WithCredentialsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      deps: [UserCacheService],
      useValue: (userService: { getLanguage: () => any }) =>
        userService.getLanguage(),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
